import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
// import Vue from 'vue'

const errorMsg = (message) => {
  return Message({
    message: message,
    type: 'error',
    duration: 2000
  })
}

axios.defaults.withCredentials = false

export const isDev = process.env.NODE_ENV === 'development'

// var url = 'https://o2o.bkycms.com'
// const backendPath = isDev ? url : location.href.match(/(\S*)views/)[1] + 'index.php/'
// http://192.168.2.99:8080/#/person?uniacid=44
// http://192.168.2.99:8080/#/join?uniacid=44

const backendPath = location.href.match(/(\S*)views/)[1] + 'index.php/'
// var backendPath = 'https://o2o.bkycms.com'

const upload = backendPath + '/common/file/upload'
const service = axios.create({
  baseURL: backendPath,
  timeout: 6000

})
// 拦截器
service.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV !== 'preview') {
      if (config.data) {
        // config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    // eslint-disable-next-line no-unused-vars
    const { status, data, config } = response
    const { code, msg } = data

    if (code === 2) {
      switch (code) {
        case undefined:
          errorMsg(msg || `后端接口${code}异常`)
          // store.dispatch("user/resetAccessToken");
          break
        default:
          errorMsg(msg || `后端接口${code}异常`)
          break
      }
      // Vue.prototype.bus.$emit('loading', false)
      return Promise.reject(
        '请求异常拦截:' +
          JSON.stringify({ url: config.url, code, msg }) || 'Error'
      )
    } else {
      // console.log('666',data)
      return data
    }
  },
  (error) => {
    /* 网络连接过程异常处理*/
    let { message } = error
    if (message === 'Network Error') {
      message = '后端接口连接异常'
    }
    if (message.includes('timeout')) {
      message = '后端接口请求超时'
    }
    if (message.includes('Request failed with status code')) {
      message = '后端接口' + message.substr(message.length - 3) + '异常'
    }
    // Vue.prototype.bus.$emit('loading', false)
    errorMsg(message || '后端接口未知异常')
    return Promise.reject(error)
  }
)
const api = {
  regionSave: (params) => {
    return service({
      method: 'post',
      url: '/common/region/region-save',
      data: params
    })
  },
  getCity: (params) => {
    return service({
      method: 'post',
      url: '/common/common/get-city',
      params: params
    })
  },
  getCategory: (params) => {
    return service({
      method: 'get',
      url: '/common/common/category-list',
      params: params
    })
  },
  saveStore: (params) => {
    return service({
      method: 'post',
      url: '/common/shop/save-store',
      data: params
    })
  },
  getConfig: (params) => {
    return service({
      method: 'get',
      url: '/common/common/config',
      params: params
    })
  }

}
export { api, upload }




// WEBPACK FOOTER //
// ./src/api/api.js